export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12067.63c86e05.jpg";